module.exports = __webpack_public_path__ + "img/thunderstorm.22fff390.svg";